const { default: Overlay } = await import('@components/overlays')

export default class Submenu extends Overlay {
    constructor(submenu, button) {
        super(submenu, { stackable: true })
        this.submenu = submenu
        this.button = button

        this.button.addEventListener('click', this.toggle)

        addEventListener('click', e => {
            if (this.isOpened && !this.submenu.contains(e.target) && !this.button.contains(e.target)) this.close()
        }, true)

        addEventListener('closesubmenus', this.close)
    }


    open() {
        super.open()
        this.submenu.classList.add('is-visible')
        this.button.setAttribute('aria-expanded', true)
    }

    close() {
        super.close()
        this.submenu.classList.remove('is-visible')
        this.button.setAttribute('aria-expanded', false)
    }
}